import { useMonthScheduleStates, useScheduleControls } from '@lp/features/Scheduler/hooks';
import { SchedulerLoadingOverlay } from '@lp/features/Scheduler/components';
import { MonthNavigationButtons } from '@lp/features/Scheduler/components/SchedulerControlHeader/components';
import { useCCSchedulerData, useMyCCShiftChange } from '@lp/features/Scheduler/SchedulerClinicalCoordinators/hooks';
import { initialPCCSchedulerControlFilters } from '@lp/features/Scheduler/SchedulerClinicalCoordinators/constants';
import { useFilters } from '@/hooks/useFilters';
import { PCCScheduleGrid, PCCSchedulerControlRow } from './components';
import { useProfileQuery } from '@/queries/user';

export const SchedulerClinicalCoordinatorPersonalView = () => {
  const { data: profileData } = useProfileQuery();
  const filters = useFilters(initialPCCSchedulerControlFilters);
  const { startDay, selectedDate, selectedDateRange, daysInterval, onMonthPrev, onMonthNext, onDateChange } =
    useScheduleControls();
  const { shiftsData, isShiftsLoading, monthSchedule } = useCCSchedulerData({ startDay, dateRange: selectedDateRange });
  const onShiftChange = useMyCCShiftChange(selectedDateRange, monthSchedule);
  const { isUnplannedPreSchedule } = useMonthScheduleStates(monthSchedule);

  if (!shiftsData || !profileData) return null;

  return (
    <div className="flex flex-col min-h-full">
      <div className="p-6 pb-0">
        <div className="flex flex-col gap-6">
          <MonthNavigationButtons selectedDate={selectedDate} onMonthPrev={onMonthPrev} onMonthNext={onMonthNext} />
          <PCCSchedulerControlRow
            shiftsData={shiftsData}
            selectedDate={selectedDate}
            filters={filters}
            onDateChange={onDateChange}
          />
        </div>
      </div>
      <div className="flex flex-col gap-6 relative p-6 h-full">
        {isShiftsLoading && <SchedulerLoadingOverlay />}

        <div className="flex flex-col p-3 bg-white rounded-large shadow-small">
          <PCCScheduleGrid
            resourceId={profileData.employee.id}
            selectedDate={selectedDate}
            daysInterval={daysInterval}
            shiftsData={shiftsData}
            isEditable={isUnplannedPreSchedule}
            canResetShifts={isUnplannedPreSchedule}
            filters={filters.filters}
            onShiftChange={onShiftChange}
          />
        </div>
      </div>
    </div>
  );
};
